import { render, staticRenderFns } from "./DepartList2.vue?vue&type=template&id=3f65c8a4&scoped=true"
import script from "./DepartList2.vue?vue&type=script&lang=js"
export * from "./DepartList2.vue?vue&type=script&lang=js"
import style0 from "./DepartList2.vue?vue&type=style&index=0&id=3f65c8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f65c8a4",
  null
  
)

export default component.exports